module.exports = __webpack_public_path__ + "img/appAsset-brand--Diners.fbcbd336.svg";